module.exports = __webpack_public_path__ + "75c446046c2f84e049260b8479f36226.svg";